$(document).ready(function(){

  if ($("#quiz").length){

    $("#question-check").click(function(){
      quizEvaluateAnswer();
    });
  }

});

function quizEvaluateAnswer(){

  var target = parseInt($("#percentage-value").val());
  var accuracies = JSON.parse($("#answer-accuracies").val());
  var accuracy = 0;
  $.each(accuracies,function(key,value){
    console.log(key+"<"+target);
    if (key<target){
      accuracy = parseInt(value);
    }
  });

  // Set up valid answer range
  var targetMinimum = target-accuracy;
  var targetMaximum = target+accuracy;

  console.log(targetMinimum+" < "+target+" > "+targetMaximum);

  var correct = false;
  var answer = $("input[name='answer']:checked").val();
  // Evaluate Correctness
  if (answer>=targetMinimum && answer<=targetMaximum){
    correct = true;
    $("#question-correct").show();
  }else{
    $("#question-wrong").show();
  }

  // Toggle Answer Text
  //$("#question-evaluation").show();

  // Highlight answers
  if (!correct){
    var tempVal = $("input[name='answer']:checked").val();
    $("#answer-"+tempVal+"-label").addClass("text-danger");
  }
  $("input[name='answer']").each(function(){
    var tempVal = $(this).val();
    if (tempVal>=targetMinimum && tempVal<=targetMaximum){
      $("#answer-"+tempVal+"-label").addClass("text-success");
    }

  });


  // Flip Buttons
  $("#question-check").hide();
  $("#question-submit").show();
}



// WEBPACK FOOTER //
// ./resources/assets/js/public/quiz.js